// extracted by mini-css-extract-plugin
export var background = "styles-module__background___PnMPp";
export var darker = "styles-module__darker___QGr6R";
export var image = "styles-module__image___GvTjP";